<template>
  <div class="modal-backdrop" @click.self="$emit('close')">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">{{ t('footer.termsOfService') }}</h2>
        <button @click="$emit('close')" class="modal-close" aria-label="Close">
          <svg style="width: 1.5rem; height: 1.5rem" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <div class="markdown-content" v-html="renderedMarkdown" />
      </div>

      <div class="modal-footer">
        <button @click="$emit('close')" class="btn btn-primary w-full">
          {{ t('common.close') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { marked } from 'marked';
import { useI18n } from 'vue-i18n';

import termsOfServiceEn from '@/i18n/legal/termsOfService.en.md?raw';

defineEmits<{ close: [] }>();

const { t } = useI18n();

marked.setOptions({ breaks: true, gfm: true });

const renderedMarkdown = computed(() => marked.parse(termsOfServiceEn));
</script>
